import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(value: any, key: any, filterKey: any): any {
    // console.log(key,filterKey)
    // if (value != undefined) {
    //   console.log(value, filterKey, key, typeof (filterKey))
    //   return value.filter((item: any) => {
    //     if (typeof filterKey == 'string' && item[key].toLowerCase().includes(filterKey.toLowerCase())) {
    //       console.log(item)
    //       return item;
    //     }
    //     else {
    //       console.log(filterKey)
    //       filterKey.filter(element => {
    //         if (item[key].toLowerCase().includes(element.toLowerCase())) {
    //           return item
    //         }
    //       });
    //     }
    //   });
    // } else { return value; }
    if (filterKey == '' || key == '') return value
    else {
      return value.filter((item: any) => {
        // console.log(item[filterKey].includes(key))
        if (item[key].toLowerCase().includes(filterKey.toLowerCase())) {
          return item;
        }
      });
    }
  }

}
